require('./checkIsLoggedIn.js');
require('./images_src_by_key.js');
require('./open_support.js');
require('./translates.js');
require('./appLinks.js');
require('./enable_tracking.js');

require('./sidemenu.js');
require('./slider.js');
require('./accordions.js');

require('./popups/forgotPass.js');
require('./popups/toggle.js');
require('./popups/input.js');
require('./popups/customSelect.js');
require('./popups/couponClick.js');
require('./popups/activate_forms.js');
